export default "__VITE_ASSET__ab43fd7f__"